/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* Audience configuration for StackAdapt campaign
*/
export class V3StackAdaptAudience {
    /**
    * Custom segment exclusion IDs
    */
    'customSegmentExclusionIds'?: Array<string>;
    /**
    * Custom segment IDs
    */
    'customSegmentIds'?: Array<string>;
    /**
    * Demographic segment IDs
    */
    'demographicSegmentIds'?: Array<string>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "customSegmentExclusionIds",
            "baseName": "customSegmentExclusionIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "customSegmentIds",
            "baseName": "customSegmentIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "demographicSegmentIds",
            "baseName": "demographicSegmentIds",
            "type": "Array<string>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptAudience.attributeTypeMap;
    }

    public constructor() {
    }
}

